var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Rectangle",attrs:{"id":"alert"}},[_c('img',{staticClass:"alert-icon",attrs:{"src":_vm.alert}}),_c('p',{staticClass:"error-alert"},[_vm._v(_vm._s(_vm.$t("errors." + _vm.errorMsg)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }